// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const dialogActions = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(24)}`,
      backgroundColor: "#252525",
      borderTop: "1px solid rgba(255, 255, 255, 0.12)",
    },
  },
};

export default dialogActions;
